import {SagaIterator} from 'redux-saga';
import {FULFILLED, PENDING} from 'redux-promise-middleware';
import {pushDataLayer} from '@optimaxdev/analytics/mobile';

import {QuoteItemType} from 'constants/flow/flowTypesCart';
import {CART} from 'constants/actions';
import {ActionType} from 'constants/flow/flowTypes';
import {GTM_REMOVE_FROM_CART} from 'constants/analytics/events';
import {isHtoEnabled} from 'constants/flags/flags';

import {call, select, takeEvery} from 'redux-saga/effects';
import {getQuoteItems} from 'selectors/cart/cart';
import {productToEECCart, productToEECCartHto} from 'libs/EEC/convertData/productToEECCart';

/**
 * Send to dataLayer event removeFromCart
 * @param {QuoteItemType} item - cart items
 */
export function sendRemoveFromCartEvent(item: QuoteItemType) {
    const preparedItems = isHtoEnabled() ? productToEECCartHto([item]) : productToEECCart([item]);
    pushDataLayer({
        event: GTM_REMOVE_FROM_CART,
        ecommerce: {
            remove: {
                products: preparedItems,
            },
        },
    });
}

/**
 * Find removed items of cart
 * @param {ActionType<void, QuoteItemType>} action - payload action
 */
export function* removedCartItem({meta = {id: ''}}: ActionType<void, {id: string}>): SagaIterator {
    const {id} = meta;
    const quoteItems = yield select(getQuoteItems);
    const removedItem = quoteItems.find(item => item.id === id);
    if (removedItem) yield call(sendRemoveFromCartEvent, removedItem);
}

/**
 * Handle decrease items of cart
 * @param {ActionType<void, QuoteItemType>} action - payload action
 */
export function* decreasedCartHandle({
    meta,
}: ActionType<void, {qty: number; quoteItemId: string}>): SagaIterator {
    if (!meta) return;
    const {qty, quoteItemId} = meta;
    const quoteItems = yield select(getQuoteItems);
    const decreasedItem = quoteItems.find(
        (item: QuoteItemType) => item.id === quoteItemId && item.qty > qty,
    );
    if (!decreasedItem) return;
    const decreasedQty = decreasedItem.qty - qty;
    yield call(sendRemoveFromCartEvent, {
        ...decreasedItem,
        qty: decreasedQty,
        total: String((+decreasedItem.total / decreasedItem.qty) * decreasedQty),
    });
}

/**
 * Begin of saga.
 */
export default function* removeFromCartSaga(): SagaIterator {
    yield takeEvery(`${CART.REMOVE_QUOTE_ITEM}_${FULFILLED}`, removedCartItem);
    yield takeEvery(
        [`${CART.CHANGE_ITEM_QTY}_${PENDING}`, `${CART.CHANGE_LENSES_ITEM_QTY}_${PENDING}`],
        decreasedCartHandle,
    );
}
